import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', () => {
  const loading = ref(true);

  const routeLoader = ref('');

  const showHero = ref(false);

  const showExpirationDialog = ref(false);

  const showBusinessFeaturesDialog = ref(false);

  // Set when the API reports that another tab has logged in as a different participant
  const participantChanged = ref(false);

  return {
    loading,
    routeLoader,
    showHero,
    showExpirationDialog,
    showBusinessFeaturesDialog,
    participantChanged,
  };
});
